import helpers from "./helper.js";
const Token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.GIQXq66H-uGpPyOb_FnG_7WxgoQM3a9w_jkoLFwZFG8";

export const getApiWrapper = async (url) => {
 
 
    const result = await helpers.httpGet(url, Token);
    console.log(result)
    return result;
};

export const getRequest = async (url,logged_in_node) => {
  try {
    const token =  logged_in_node && logged_in_node.Token ?logged_in_node.Token : "";
    let headers = {};
    if (token) {
      headers["Authorization"] = "Token " + token;
    }
    console.debug('request from get url: ', url);
    let response = await fetch(url, {
      method: "GET",
      headers: headers
    });
    let responseJson = await response.json();
    if (response.status == 500) {
      throw responseJson;
    } else {
      console.debug('response from get url: ' + url + ' is: ', responseJson);
      return responseJson;
    }
  } catch (e) {
    throw e;
  }
};

export const postRequest = async (url, body,logged_in_node, token=null) => {
  try {
    token=Token;
    if (!token) {
      token =  logged_in_node && logged_in_node.Token ?logged_in_node.Token : "";
    }
    let headers = { "Content-Type": "application/json" };
    if (token) {
      headers["Authorization"] = "Token " + token;
    }
    console.debug('request from post url: ' + url + ' is: ', body);
    let response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body)
    });
    let responseJson = await response.json();
    if (response.status == 500) {
      throw responseJson;
    } else {
      console.debug('response from post url: ' + url + ' is: ', responseJson);
      return responseJson;
    }
  } catch (e) {
    throw e;
  }
};

export const postApiWrapper = async (url, data) => {
 
  if (Token) {
    const result = await helpers.httpPost(url, Token, data);
    return result;
  }
};
